import { gql } from '@apollo/client';

export const ASSOCIATE_PARTNER_TO_HIERARCHY_NODE = gql`
  mutation associatePartnerToHierarchyNode($input: AssociatePartnerToHierarchyNodeInput) {
    associatePartnerToHierarchyNode(input: $input) {
      detail {
        partnerHierarchyDetailId
        partnerHierarchyId
        category
        partnerId
        parentDetailId
        path
        partnerName
      }
    }
  }
`;


export const ASSOCIATE_PARTNERS_UNDER_HIERARCHY_NODE = gql`
  mutation associatePartnersUnderHierarchyNode($input: associatePartnersUnderHierarchyNodeInput) {
    associatePartnersUnderHierarchyNode(input: $input) {
      details {
        partnerHierarchyDetailId
        partnerHierarchyId
        category
        partnerId
        parentDetailId
        path
        partnerName
      }
    }
  }
`;

